// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ApplicantDTO } from './applicant-dto';
import { CheckDTO } from './check-dto';
import { ReferenceDocumentDTO } from './reference-document-dto';
import { ReferenceLinksDTO } from './reference-links-dto';

/**
 * 
 * @export
 * @interface ReferenceDTO
 */
export interface ReferenceDTO {
    /**
     * 
     * @type {string}
     * @memberof ReferenceDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDTO
     */
    status: ReferenceDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDTO
     */
    applicantId?: string;
    /**
     * 
     * @type {Array<ReferenceDocumentDTO>}
     * @memberof ReferenceDTO
     */
    documents: Array<ReferenceDocumentDTO>;
    /**
     * 
     * @type {ApplicantDTO}
     * @memberof ReferenceDTO
     */
    applicant: ApplicantDTO;
    /**
     * 
     * @type {Array<CheckDTO>}
     * @memberof ReferenceDTO
     */
    checks: Array<CheckDTO>;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDTO
     */
    createdAt: string;
    /**
     * 
     * @type {ReferenceLinksDTO}
     * @memberof ReferenceDTO
     */
    links: ReferenceLinksDTO;
}

/**
    * @export
    * @enum {string}
    */
export enum ReferenceDTOStatusEnum {
    EMPTY = 'EMPTY',
    PEND = 'PEND',
    INFOREQUIRED = 'INFO_REQUIRED',
    INREVIEW = 'IN_REVIEW',
    PASS = 'PASS',
    FAIL = 'FAIL',
    GUARANTORREQUIRED = 'GUARANTOR_REQUIRED'
}



